var map = {
	"./account-balance.svg": [
		64911,
		4911
	],
	"./add-person.svg": [
		88942,
		8942
	],
	"./addDocument.svg": [
		22411,
		2411
	],
	"./arrow-down.svg": [
		495,
		495
	],
	"./arrow-left.svg": [
		9680,
		9680
	],
	"./arrow-right.svg": [
		26559,
		6559
	],
	"./bill.svg": [
		64968,
		4968
	],
	"./boleto-payment-checked.svg": [
		57277,
		7277
	],
	"./boleto-payment.svg": [
		48405,
		8405
	],
	"./boleto.svg": [
		85580,
		5580
	],
	"./calendar.svg": [
		33033,
		3033
	],
	"./cancel-recharge.svg": [
		65353,
		5353
	],
	"./card.svg": [
		4929,
		4929
	],
	"./cart-empty.svg": [
		96509,
		6509
	],
	"./cart-not-empty.svg": [
		1713,
		1713
	],
	"./check-circle-green.svg": [
		94932,
		4932
	],
	"./check-circle-outlined.svg": [
		28497,
		8497
	],
	"./check-circle.svg": [
		77694,
		7694
	],
	"./circle-plus.svg": [
		52520,
		2520
	],
	"./close-filled.svg": [
		52934,
		2934
	],
	"./confirm-recharge.svg": [
		61285,
		1285
	],
	"./copy.svg": [
		61960,
		1960
	],
	"./credit-card.svg": [
		84275,
		4275
	],
	"./document.svg": [
		86808,
		6808
	],
	"./dollar.svg": [
		77081,
		7081
	],
	"./download.svg": [
		72999,
		2999
	],
	"./edit.svg": [
		47759,
		7759
	],
	"./email-outlined.svg": [
		7168,
		7168
	],
	"./email.svg": [
		88753,
		8753
	],
	"./error.svg": [
		73023,
		3023
	],
	"./export.svg": [
		33637,
		3637
	],
	"./external-link.svg": [
		67335,
		7335
	],
	"./file-download.svg": [
		42786,
		2786
	],
	"./filter.svg": [
		43569,
		3569
	],
	"./finance.svg": [
		82635,
		2635
	],
	"./grupo.svg": [
		30434,
		434
	],
	"./home.svg": [
		41502,
		1502
	],
	"./instagram.svg": [
		95261,
		5261
	],
	"./key.svg": [
		52104,
		2104
	],
	"./link.svg": [
		30639,
		639
	],
	"./linkedin-rect.svg": [
		65800,
		5800
	],
	"./location.svg": [
		39702,
		9702
	],
	"./md-card.svg": [
		75243,
		5243
	],
	"./meal.svg": [
		75946,
		5946
	],
	"./ok.svg": [
		99217,
		9217
	],
	"./options-outline-svgrepo-com.svg": [
		4331,
		4331
	],
	"./pencil-recharge.svg": [
		76130,
		6130
	],
	"./people-fill.svg": [
		52728,
		2728
	],
	"./pin.svg": [
		18352,
		8352
	],
	"./pix-payment-checked.svg": [
		79295,
		9295
	],
	"./pix-payment.svg": [
		16755,
		6755
	],
	"./pix.svg": [
		97422,
		7422
	],
	"./power.svg": [
		96222,
		6222
	],
	"./qr-code.svg": [
		24,
		24
	],
	"./qrcode-finished.svg": [
		92020,
		2020
	],
	"./receipt.svg": [
		25629,
		5629
	],
	"./recharge.svg": [
		43312,
		3312
	],
	"./repeat.svg": [
		93578,
		3578
	],
	"./request-list.svg": [
		47975,
		7975
	],
	"./search.svg": [
		25975,
		5975
	],
	"./shopping-cart.svg": [
		13814,
		3814
	],
	"./signatures.svg": [
		73514,
		3514
	],
	"./slash.svg": [
		95522,
		5522
	],
	"./spinner-pix-copy.svg": [
		62808,
		2808
	],
	"./spinner.svg": [
		79742,
		9742
	],
	"./step-disabled.svg": [
		47910,
		7910
	],
	"./team.svg": [
		35296,
		5296
	],
	"./telephone-fill.svg": [
		46373,
		6373
	],
	"./term-bill-checked.svg": [
		30417,
		417
	],
	"./term-bill.svg": [
		63833,
		3833
	],
	"./transport.svg": [
		25602,
		5602
	],
	"./trash-2.svg": [
		77022,
		7022
	],
	"./trash-recharge.svg": [
		28299,
		8299
	],
	"./trash.svg": [
		68699,
		8699
	],
	"./triangle.svg": [
		97315,
		7315
	],
	"./twitter-bird.svg": [
		16588,
		6588
	],
	"./upload.svg": [
		96840,
		6840
	],
	"./user-settings.svg": [
		77444,
		7444
	],
	"./warning.svg": [
		11441,
		1441
	],
	"./x.svg": [
		37017,
		7017
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 34266;
module.exports = webpackAsyncContext;